<template>
  <div class="mainInputField">
    <label>{{ label }}</label>
    <textarea
      rows="6"
      id="id"
      type="text"
      :placeholder="placeholder"
      :value="value"
      @input="$emit('input', $event.target.value)"
    ></textarea>
    <div v-if="errors" class="helperError">{{ errors[0] }}</div>
  </div>
</template>

<script>
export default {
  name: "TextAreaInputField",
  components: {},
  props: ["value", "errors", "label", "placeholder"],
  data() {
    return {};
  },

  mounted() {},
};
</script>
